import axios from 'axios';
import { Message, Loading } from 'element-ui';
import _ from 'lodash';
import { getToken } from '@/utils/auth';
import router from '@/router';

// =============== Loading 控制 ===============
let loadingInstance;
let needLoadingRequestCount = 0;

function showLoading(target) {
    console.log(target);

    if (needLoadingRequestCount === 0 && !loadingInstance) {
        loadingInstance = Loading.service({
            lock: true,
            text: '加载中...',
            background: 'rgba(255, 255, 255, 0.5)',
            customClass: 'custom-loading-center',
        });
    }
    needLoadingRequestCount++;
}

const tryCloseLoading = _.debounce(() => {
    if (loadingInstance) {
        loadingInstance.close();
        loadingInstance = null;
    }
}, 300);

function hideLoading() {
    needLoadingRequestCount = Math.max(needLoadingRequestCount - 1, 0);
    if (needLoadingRequestCount === 0) {
        tryCloseLoading();
    }
}

// =============== 创建 Axios 实例 ===============
// 开发环境使用代理前缀 /api，生产环境使用真实域名
const baseURL = process.env.VUE_APP_BASE_API || '/api';

const service = axios.create({
    baseURL,
    timeout: 6000000, // 60秒超时
});

// =============== 请求拦截器 ===============
service.interceptors.request.use(
    (config) => {
        console.log(config, 'config');

        // 设置 Authorization
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = token;
        }

        // 控制 loading
        const showLoadingFlag = config.headers.showLoading !== false;
        if (showLoadingFlag) {
            showLoading(config.headers.loadingTarget);
        }

        return config;
    },
    (error) => {
        // 一般不会触发，但需处理
        hideLoading();
        return Promise.reject(error);
    }
);

// =============== 响应拦截器 ===============
service.interceptors.response.use(
    (response) => {
        // 隐藏 loading
        if (response.config.headers.showLoading !== false) {
            hideLoading();
        }

        const res = response.data;

        // 处理空响应
        if (res === null || res === undefined) {
            const errorMsg = '无效的响应数据';
            Message.error(errorMsg);
            return Promise.reject(new Error(errorMsg));
        }

        // 根据后端 code 处理业务逻辑
        if (res.code === 200) {
            return res; // 成功
        }

        if (res.code === 403) {
            Message.error(res.msg || '登录已失效，请重新登录');
            // 清除本地 token（如果有的话）
            // import { removeToken } from '@/utils/auth'; removeToken();
            router.push('/login');
            return Promise.reject(new Error('登录已失效'));
        }

        // 其他业务错误
        Message.error(res.msg || '请求失败');
        return Promise.reject(new Error(res.msg || '请求失败'));
    },
    (error) => {
        // 隐藏 loading
        if (error.config?.headers?.showLoading !== false) {
            hideLoading();
        }

        // 统一错误提示
        const response = error.response;
        const request = error.request;

        let msg = '';

        // 优先使用自定义 msg
        if (error.msg) {
            msg = error.msg;
        } else if (response) {
            // 服务器返回了错误
            msg = response.data?.message || response.data?.msg || response.statusText || `请求失败: ${response.status}`;
        } else if (request) {
            // 网络错误，无响应
            msg = '网络连接失败，请检查网络';
        } else {
            msg = error.message || '请求失败';
        }

        Message({
            message: msg,
            type: 'error',
            duration: 5 * 1000,
        });

        return Promise.reject(error);
    }
);

export default service;
